import React from 'react';

import './style.scss';

interface TikTokFeedProps {
  url: string;
}

const TikTokFeed: React.FC<TikTokFeedProps> = ({ url }) => (
  <div className="TikTokFeed">
    <blockquote
      className="tiktok-embed"
      cite={`https://www.tiktok.com/@${url}`}
      data-unique-id={url}
      data-embed-type="creator"
      id="v17087855090944170"
    >
      <iframe
        title="tiktok"
        name="__tt_embed__v17087855090944170"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin"
        src={`https://www.tiktok.com/embed/@${url}?lang=en-GB`}
      />
    </blockquote>
    <script async src="https://www.tiktok.com/embed.js" />
  </div>
);

export default TikTokFeed;

